<section class="py-3">
  <div class="container-fluid card">
    <div class="d-flex flex-column flex-sm-row justify-content-between align-items-sm-center mb-3 pt-3 gap-2">
      <app-main-heading [heading]="'Vehicle Model'" class="m-0 align-self-start align-self-sm-auto"></app-main-heading>
      <div class="align-self-end align-self-sm-auto">
        <button class="btn app-btn-primary" (click)="vehicleModelFormPopup('add')">Add Vehicle Model</button>
      </div>
    </div>
    <div class="card app-table-thick-border shadow-none mb-2">
      <div class="table-responsive app-scrollbar" infiniteScroll [scrollWindow]="false" [infiniteScrollDistance]="2" [infiniteScrollThrottle]="300" (scrolled)="loadMore()">
        <table class="table app-table-rounded align-middle m-0 w-100">
          <thead>
            <tr class="app-table-header">
              <th scope="col" sortable="">Name</th>
              <th scope="col" sortable="">Vehicle Make</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody>
            @if (modelList.length > 0) {
              @for (list of modelList; track list) {
                <tr class="app-table-body app-td-text">
                  <td class="td-text-three">{{list.name}}</td>
                  <td class="td-text-two text-muted">{{list.vehicleMake}}</td>
                  <td>
                    <fa-icon class="btn app-btn-primary btn-sm" (click)="vehicleModelFormPopup('edit',list)" [icon]="faEdit" size="lg"
                    ngbTooltip="Edit" [placement]="'right'"></fa-icon> &nbsp;
                  </td>
                </tr>
              }
            }

            @if (loader) {
              <tr>
                <td colspan="3">
                  <div class="custom-col-width-100 d-flex justify-content-center py-5">
                    <app-loader [loadingIcon]="loader"></app-loader>
                  </div>
                </td>
              </tr>
            }

            @if (!loader && modelList.length === 0) {
              <tr>
                <td colspan="3">
                  <div class="custom-col-width-100 text-danger d-flex justify-content-center py-5 fw-semibold">
                    No Records Found!
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>



  @if (showEditPopup) {
    <div class="popup-overlay">
      <div class="popup-container">
        <h3>{{popupType}} Vehicle Model</h3>
        <form [formGroup]="vehicleModelForm" (ngSubmit)="onEditSubmit()">
          <div class="row pt-2 g-2">
            <div class="col-12 col-md-6 mb-2">
              <label for="name" class="form-label">Name<span class="text-danger">*</span></label>
              <input formControlName="name" id="name" type="text" class="form-control default-form-group-border" required
                placeholder="Enter name">
                @if (
                  vehicleModelForm.get('name')?.invalid &&
                  vehicleModelForm.get('name')?.touched
                  ) {
                  <div>
                    <small class="text-danger">Name is required</small>
                  </div>
                }
              </div>
              <div class="col-12 col-md-6 mb-2">
                <label for="vehicleMakeSelect" class="form-label">Vehicle Make<span class="text-danger">*</span></label>
                <ng-select labelForId="vehicleMakeSelect" [items]="makeListr" bindLabel="name" bindValue="name" [multiple]="false"
                  [clearable]="true" [searchable]="true" placeholder="Search or Select Vehicle Make"
                  formControlName="vehicleMake" class="ng-select-bootstrap" [searchFn]="customSearchFn"
                  dropdownPosition="top" appendTo=".popup-overlay" dropdownClass="tyre-model-dropdown-panel"
                  (search)="onVehicleMakeInputChange($event)" (scrollToEnd)="scroll()">
                </ng-select>
                </div>
                @if (errorMessage) {
                  <div class="text-danger mb-2">{{errorMessage}}</div>
                }
              </div>
              <!-- Action Buttons -->
              <div class="row pt-3">
                <div class="col-12 d-flex justify-content-end gap-2 button_section">
                  <button type="button" class="btn pr-2" (click)="closePopup()">Cancel</button>
                  <button type="submit" class="btn app-btn-primary sub_button" [disabled]="vehicleModelForm.invalid">
                    {{popupType}}
                    @if (isLoading) {
                      <output class="spinner-border spinner-border-sm ms-1" aria-hidden="true"></output>
                    }
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      }
    </section>

    @if (isToster) {
      <app-toaster [title]="message" (closeToaster)="closeToster($event)"></app-toaster>
    }